import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { database } from './firebaseConfig';
import Navbar from './components/Navbar';
import Pendientes from './components/Pendientes';
import CalendarPage from './components/CalendarPage';
import WorldCupResults from './components/WorldCupResults';
import QRRedirect from './components/QRRedirect';

const auth = getAuth();

function LoginForm({ handleLogin, email, setEmail, password, setPassword, error }) {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div style={{
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f0f2f5',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
            background: 'linear-gradient(135deg, #f0f2f5 0%, #e3e8ef 100%)'
        }}>
            <div style={{
                background: '#fff',
                padding: '40px',
                borderRadius: '16px',
                boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
                width: '100%',
                maxWidth: '400px',
                textAlign: 'center'
            }}>
                <div style={{
                    marginBottom: '35px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '15px'
                }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/gnapps-logo.webp`}
                        alt="Logo"
                        style={{
                            width: '120px',
                            height: '120px',
                            objectFit: 'contain',
                            marginBottom: '10px'
                        }}
                    />
                    <div>
                        <h2 style={{
                            color: '#1a3b5d',
                            fontSize: '2rem',
                            margin: '0 0 10px 0',
                            fontWeight: '600'
                        }}>
                            Bienvenido
                        </h2>
                    </div>
                </div>

                <form onSubmit={handleLogin} style={{ textAlign: 'left' }}>
                    {error && (
                        <div style={{
                            backgroundColor: '#fff5f5',
                            color: '#dc3545',
                            padding: '12px 16px',
                            borderRadius: '8px',
                            fontSize: '0.9rem',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            border: '1px solid rgba(220, 53, 69, 0.1)'
                        }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="8" x2="12" y2="12" />
                                <line x1="12" y1="16" x2="12" y2="16" />
                            </svg>
                            {error}
                        </div>
                    )}

                    <div style={{ marginBottom: '20px' }}>
                        <label
                            htmlFor="email"
                            style={{
                                display: 'block',
                                marginBottom: '8px',
                                color: '#1a3b5d',
                                fontSize: '0.95rem',
                                fontWeight: '500'
                            }}
                        >
                            Correo electrónico
                        </label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="ejemplo@correo.com"
                                style={{
                                    width: '100%',
                                    padding: '12px 12px 12px 40px',
                                    borderRadius: '8px',
                                    border: '1px solid #ced4da',
                                    fontSize: '0.95rem',
                                    transition: 'all 0.2s',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#4a90e2';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(74, 144, 226, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#ced4da';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                            <svg
                                style={{
                                    position: 'absolute',
                                    left: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#666'
                                }}
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                            </svg>
                        </div>
                    </div>

                    <div style={{ marginBottom: '25px' }}>
                        <label
                            htmlFor="password"
                            style={{
                                display: 'block',
                                marginBottom: '8px',
                                color: '#1a3b5d',
                                fontSize: '0.95rem',
                                fontWeight: '500'
                            }}
                        >
                            Contraseña
                        </label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                                style={{
                                    width: '100%',
                                    padding: '12px 12px 12px 40px',
                                    borderRadius: '8px',
                                    border: '1px solid #ced4da',
                                    fontSize: '0.95rem',
                                    transition: 'all 0.2s',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#4a90e2';
                                    e.target.style.boxShadow = '0 0 0 3px rgba(74, 144, 226, 0.1)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#ced4da';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                            <svg
                                style={{
                                    position: 'absolute',
                                    left: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#666'
                                }}
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                            </svg>
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    padding: '0',
                                    cursor: 'pointer',
                                    color: '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                            >
                                {showPassword ? (
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                        <line x1="1" y1="1" x2="23" y2="23" />
                                    </svg>
                                ) : (
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                        <circle cx="12" cy="12" r="3" />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <button
                        type="submit"
                        style={{
                            width: '100%',
                            padding: '14px',
                            backgroundColor: '#1a3b5d',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '1rem',
                            fontWeight: '500',
                            transition: 'all 0.2s',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            boxShadow: '0 2px 4px rgba(26, 59, 93, 0.2)',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#2c5282';
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 4px 6px rgba(26, 59, 93, 0.2)';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#1a3b5d';
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 2px 4px rgba(26, 59, 93, 0.2)';
                        }}
                    >
                        <span>Iniciar Sesión</span>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                        >
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </button>
                </form>
            </div>
        </div>
    );
}

function AppContent() {
    // Todos los hooks deben ir aquí, antes de cualquier return o condición
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isPublicador, setIsPublicador] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [authLoading, setAuthLoading] = useState(true);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [tienePublicacionesNoVistas, setTienePublicacionesNoVistas] = useState(false);

    // Añadir verificación de conexión
    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
        };

        const handleOffline = () => {
            setIsOnline(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    // Componente para la alerta de desconexión
    const OfflineAlert = () => (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#dc3545',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            zIndex: 9999,
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            animation: 'slideUp 0.3s ease-out'
        }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M1 1l22 22M16.72 11.06A10.94 10.94 0 0112 12c0 5.52-4.48 10-10 10-2.76 0-5.26-1.12-7.07-2.93m0 0a10.94 10.94 0 01-1.93-6.07c0-5.52 4.48-10 10-10 2.76 0 5.26 1.12 7.07 2.93" />
            </svg>
            No hay conexión a internet
            <style>{`
                @keyframes slideUp {
                    from { transform: translate(-50%, 100%); }
                    to { transform: translate(-50%, 0); }
                }
            `}</style>
        </div>
    );

    const checkUserStatus = async (user) => {
        try {
            const adminRef = ref(database, `Administrador/${user.uid}`);
            const publicadorRef = ref(database, `Publicador/${user.uid}`);
            const empleadoRef = ref(database, `Empleado/${user.uid}`);
            const [adminSnapshot, publicadorSnapshot, empleadoSnapshot] = await Promise.all([
                get(adminRef),
                get(publicadorRef),
                get(empleadoRef)
            ]);

            const isAdminUser = adminSnapshot.exists();
            const isPublicadorUser = publicadorSnapshot.exists();
            setIsAdmin(isAdminUser);
            setIsPublicador(isPublicadorUser);

            if (isAdminUser) {
                return { isValid: true, type: 'admin' };
            }

            if (isPublicadorUser) {
                return { isValid: true, type: 'publicador' };
            }

            if (empleadoSnapshot.exists()) {
                return {
                    isValid: true,
                    type: 'empleado',
                    nombre: empleadoSnapshot.val().nombre
                };
            }

            return { isValid: false };
        } catch (error) {
            console.error('Error al verificar usuario:', error);
            return { isValid: false };
        }
    };
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                const userStatus = await checkUserStatus(user);

                if (!userStatus.isValid) {
                    await signOut(auth);
                    setError('Usuario no autorizado.');
                    setUser(null);
                } else {
                    setUser({
                        ...user,
                        type: userStatus.type,
                        nombre: userStatus.nombre
                    });
                }
            } else {
                setUser(null);
                setIsAdmin(false);
                setIsPublicador(false);
            }
            setAuthLoading(false);
        });

        return () => unsubscribe();
    }, []);

    // Función para actualizar el estado de publicaciones no vistas
    const actualizarPublicacionesNoVistas = (valor) => {
        console.log('Actualizando estado de publicaciones no vistas:', valor);
        setTienePublicacionesNoVistas(valor);
    };

    // Agregar useEffect para escuchar cambios en las publicaciones no vistas
    useEffect(() => {
        if (!user) {
            setTienePublicacionesNoVistas(false);
            return;
        }
    }, [user]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const loggedUser = userCredential.user;
            const userStatus = await checkUserStatus(loggedUser);

            if (userStatus.isValid) {
                setUser({
                    ...loggedUser,
                    type: userStatus.type,
                    nombre: userStatus.nombre
                });
                setEmail('');
                setPassword('');
            } else {
                await signOut(auth);
                setError('No tienes permisos para acceder a esta aplicacion');
            }
        } catch (error) {
            console.error('Error al iniciar sesion:', error);
            setError('Error al iniciar sesion. Por favor, verifica tus credenciales.');
        }
    };
    const handleLogout = async () => {
        try {
            await signOut(auth);
            setUser(null);
            setIsAdmin(false);
            setError('');
        } catch (error) {
            console.error('Error al cerrar sesión:', error);
        }
    };

    if (authLoading) {
        return (
            <div style={{
                fontFamily: 'Arial, sans-serif',
                backgroundColor: '#f0f2f5',
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <div style={{
                    background: '#fff',
                    padding: '20px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}>
                    <p>Cargando...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return (
            <LoginForm
                handleLogin={handleLogin}
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
                error={error}
            />
        );
    }

    return (
        <div style={{
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f0f2f5',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }}>
            {!isOnline && <OfflineAlert />}
            {user ? (
                <>
                    <Navbar
                        handleLogout={handleLogout}
                        isAdmin={isAdmin}
                        userInfo={user}
                        tienePublicacionesNoVistas={tienePublicacionesNoVistas}
                        isPublicador={isPublicador}
                    />
                    <main style={{ flex: 1 }}>
                        <Routes>
                            <Route path="/calendar" element={
                                <rutaPrivada>
                                    <CalendarPage />
                                </rutaPrivada>
                            } />
                            <Route path="/" element={
                                <Navigate to="/pendientes" replace />
                            } />
                            <Route path="/pendientes" element={
                                <Pendientes
                                    isAdmin={isAdmin}
                                    isPublicador={isPublicador}
                                    actualizarPublicacionesNoVistas={actualizarPublicacionesNoVistas}
                                />
                            } />
                            <Route path="/pendientes/:publicacionId" element={
                                <Pendientes
                                    isAdmin={isAdmin}
                                    isPublicador={isPublicador}
                                    actualizarPublicacionesNoVistas={actualizarPublicacionesNoVistas}
                                />
                            } />
                            <Route path="/mundial" element={
                                <WorldCupResults canEdit={isAdmin || isPublicador} />
                            } />
                            <Route path="*" element={<Navigate to="/pendientes" replace />} />
                        </Routes>
                    </main>
                </>
            ) : (
                <LoginForm
                    handleLogin={handleLogin}
                    email={email}
                    setEmail={setEmail}
                    password={password}
                    setPassword={setPassword}
                    error={error}
                />
            )}
        </div>
    );
}

function QROnly() {
    return (
        <Routes>
            <Route path="/qr/:id" element={<QRRedirect />} />
        </Routes>
    );
}

export default function App() {
    const path = window.location.pathname;
    const qrMatch = /^\/qr\//.test(path);
    return (
        <Router>
            {qrMatch ? <QROnly /> : <AppContent />}
        </Router>
    );
}
